<script>
  export default {
    name: 'new-material-item',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      isExpanded: false
    })
  }
</script>

<template>
  <v-card max-width="1200" min-height="200" width="100%" class="mt-4">
    <v-card-text class="d-flex flex-column flex-sm-row">
      <v-img :src="item.thumbnail" height="100%" max-width="120" width="120" cover class="mx-auto mx-sm-0"></v-img>
      <v-sheet color="transparent" class="d-flex flex-column justify-start pl-4">
        <h5 class="text-h6 font-weight-bold">
          <a :href="item.titleCatalogUrl" target="_blank" rel="noopener noreferrer">{{ item.title }}</a>
        </h5>
        <h6 class="text-subtitle-1 primary--text">
          <a :href="item.authorCatalogUrl" target="_blank" rel="noopener noreferrer">{{ item.author }}</a>
        </h6>
        <h6 class="text-subtitle-2">{{ item.publishing || '' }}</h6>
        <v-sheet color="transparent" class="description-sheet mt-2">
          <p v-html="isExpanded ? item.description : item.descriptionShort || ''" class="text-body-1"></p>
          <v-btn v-if="item.isExpandable" color="primary" icon large @click="isExpanded = !isExpanded" class="expand-btn"
            ><v-icon large>{{ `mdi-menu-${isExpanded ? 'up' : 'down'}` }}</v-icon></v-btn
          >
        </v-sheet>
      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  .description-sheet {
    position: relative;
  }
  .expand-btn {
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
</style>
